import { FC } from 'react'

import { InputSelectControlField } from '@sequencehq/core-components'

import { ValidationResult } from 'Automations/nodeDefinitions/validation'
import { ReviewNodeOption } from './useQuoteReviewNodes'

export type ReviewNodeSelectorProps = {
  'data-testid'?: string
  /**
   * The review steps still worth picking. A step every expression is taken on
   * is left out, so a row can't be built that says nothing new.
   */
  options: ReviewNodeOption[]
  value: string
  onChange: (value: string) => void
  validationErrors?: ValidationResult[]
  /** When true, the picker auto-opens on mount. */
  initiallyOpen?: boolean
}

/**
 * Review-step picker for the PREVIOUS_APPROVAL condition property. The chosen
 * step decides which approval the comparison looks for — its approvers are the
 * assignment rules the fetch matches on.
 */
export const ReviewNodeSelector: FC<ReviewNodeSelectorProps> = ({
  'data-testid': dataTestId,
  options,
  value,
  onChange,
  validationErrors,
  initiallyOpen
}) => (
  <InputSelectControlField
    data-testid={dataTestId}
    matchWidth={false}
    value={value ?? ''}
    onChange={selected => onChange(String(selected))}
    options={options}
    placeholder="Select review..."
    validationErrors={
      validationErrors?.map(error => ({ message: error.message })) ?? []
    }
    menuWidth={{ max: '320px', min: '100px' }}
    initiallyOpen={initiallyOpen}
  />
)
